export default __webpack_public_path__ + "static/media/logo_wki.6a6d8267.png";